import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { Button, Checkbox, Col, Form, Input, Modal, Row, Select, Skeleton, Tag, Tooltip } from 'antd';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { ChevronDown, ChevronUp, CloseIcon, Information } from '../../assets/icons';
import FloatingLabel from '../../components/FloatingLabel/FloatingLabel';
import { Images } from '../../config/images';
import useMediaQuery from '../../Hooks/useMediaQuery';
import { cancelOpenOrderAction, editOrderAction } from '../../store/reducer/portfolioOpenOrderSlice';
import { getUsCurrencyFormat, getUsCurrencyFormatWithoutDecimal } from '../../utils/usCurrencyFormatter';

const EditOrderModal = (props) => {
  const { selectedProperty, propertyDetails, setOpenModal, properyLoading } = props;
  const [expandAdvanced, setExpandAdvanced] = useState(true);
  const [isScrolledBuy, setIsScrolledBuy] = useState(false);
  const [CancelOrderModal, setCancelOrderModal] = useState(false);
  const [numberOfShare, setNumberOfShare] = useState('');
  const [sellPrice, setSellPrice] = useState('');
  const [duration, setDuration] = useState('');
  const [arrowUpDuration2, setArrowUpDuration2] = useState(false);
  const [isPartialFills, setIsPartialFills] = useState(false);
  const [isTermAndConditionChecked, setIsTermAndConditionChecked] = useState(false);
  const [EditOrderThree, setEditOrderThree] = useState(false);
  const [SuccessModal, setSuccessModal] = useState(false);
  const [orderType, setOrderType] = useState('');
  const [isTextSelected, setIsTextSelected] = useState(false);
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.portfolioOpenOrder.loading);

  const handleScrollBuy = (e) => {
    if (e.target.scrollTop > 10) setIsScrolledBuy(true);
    else setIsScrolledBuy(false);
  };
  const screenMD = useMediaQuery('(min-width: 1000px)');
  // Order Modals
  const [, setEditOrderOne] = useState(false);

  const [EditOrderTwo, setEditOrderTwo] = useState(false);
  const showEditOrderTwo = () => {
    setNumberOfShare(selectedProperty?.quantity?.toString());
    setSellPrice(selectedProperty?.orderPrice?.toString());
    setDuration(selectedProperty?.duration);
    setIsPartialFills(selectedProperty?.partialFills);
    setEditOrderTwo(true);
    setEditOrderOne(false);
  };
  const hideEditOrderTwo = () => {
    setEditOrderTwo(false);
  };
  const showEditOrderThree = () => {
    setEditOrderThree(true);
    setEditOrderTwo(false);
  };
  const hideEditOrderThree = () => {
    setEditOrderThree(false);
    setEditOrderTwo(false);
    setIsTermAndConditionChecked(false);
    // setEditOrderThree(false);
  };
  const showSuccessModal = async () => {
    setOrderType('cancel');
    await dispatch(
      cancelOpenOrderAction({
        id: selectedProperty?.openOrderId,
        onSuccess: () => {
          hideCancelOrderModal();
          props.CloseFunction(false);
          setSuccessModal(true);
          setEditOrderThree(false);
          setOpenModal(false);
        },
      })
    );
  };

  const handlePlaceOrder = async () => {
    setOrderType('buyOrSell');
    await dispatch(
      editOrderAction({
        id: selectedProperty?.openOrderId,
        formData: {
          noOfShares: Number(numberOfShare),
          pricePerShare: Number(sellPrice),
          partialFills: isPartialFills === null ? false : isPartialFills,
          duration: duration,
        },
        onSuccess: () => {
          hideEditOrderTwo();
          hideEditOrderThree();
          props.CloseFunction(false);
          setIsTermAndConditionChecked(false);
          setSuccessModal(true);
          setEditOrderThree(false);
        },
      })
    );
  };
  const hideSuccessModal = () => {
    setSuccessModal(false);
    hideCancelOrderModal();
    setOpenModal(false);
  };
  const showCancelOrderModal = () => {
    setCancelOrderModal(true);
    setEditOrderOne(false);
  };
  const hideCancelOrderModal = () => {
    setCancelOrderModal(false);
  };
  const grossPrice = Number(selectedProperty?.quantity) * Number(selectedProperty?.orderPrice);
  const totalPurchase = Number(grossPrice) + Number(selectedProperty?.platformFee);
  const allTime = getUsCurrencyFormat(
    (100 *
      (Number(propertyDetails?.data?.lastPrice ? propertyDetails?.data?.lastPrice : propertyDetails?.data?.finance?.perSharePrice) -
        Number(propertyDetails?.data?.finance?.perSharePrice))) /
      Number(propertyDetails?.data?.finance?.perSharePrice) || 0
  );

  useEffect(() => {
    setNumberOfShare(selectedProperty?.quantity?.toString());
    setDuration(selectedProperty?.duration);
    setIsPartialFills(selectedProperty?.partialFills);
    setSellPrice(selectedProperty?.orderPrice?.toString());
  }, [propertyDetails]);

  let grossProceeds = Number(sellPrice) * Number(numberOfShare);
  const transactionFee = (Number(grossProceeds) * 1) / 100;
  const Netproceeds =
    selectedProperty?.type === 'Sell'
      ? getUsCurrencyFormat(numberOfShare && sellPrice ? Number(grossProceeds) - Number(transactionFee) - Number(selectedProperty?.platformFee) : 0)
      : getUsCurrencyFormat(Number(grossProceeds) + Number(transactionFee) + Number(selectedProperty?.platformFee));
  const sharesRemainingToPurchase = Number(
    ((Number(propertyDetails?.data?.totalShare) * 9.8) / 100 - Number(propertyDetails?.data?.userPurchaseDetail?.noOfShares)).toFixed(2)
  );
  const isMaxRangeError = Number(numberOfShare) > Number(sharesRemainingToPurchase);
  return (
    <>
      {screenMD && (
        <>
          {/* <Button onClick={showEditOrderOne}>Edit modal</Button> */}
          <Modal
            className='quickbuy buy-order ant-modal--footer-shadow ant-modal--both'
            open={props.EditOrderOne}
            onCancel={() => props.CloseFunction(false)}
            title={
              <div className={isScrolledBuy ? 'buy-order-header scrolled' : 'buy-order-header'}>
                <div className='header__img'>
                  {propertyDetails?.data?.images?.[propertyDetails?.data?.images?.primaryImage] ? (
                    <LazyLoadImage
                      onError={(element) => {
                        element.target.src = Images.noPropertyFoundImage;
                      }}
                      src={propertyDetails?.data?.images?.[propertyDetails?.data?.images?.primaryImage]}
                      alt='house with garden'
                    />
                  ) : (
                    <>{properyLoading ? <Skeleton.Image active={true} /> : <LazyLoadImage src={Images.noPropertyFoundImage} alt='the-leonardo' />}</>
                  )}
                </div>
                <div className='header__content'>
                  <p className='subhead-2 text-copper mb-0'>
                    {propertyDetails?.data?.name || <Skeleton.Input active={true} size='small' style={{ height: 16 }} />}
                  </p>
                  <div className='name-type'>
                    {properyLoading ? (
                      <Skeleton.Input style={{ height: 16 }} active={true} size='small' />
                    ) : (
                      <span className='fz-12 text-taupe'>{`${propertyDetails?.data?.city || ''}, ${propertyDetails?.data?.state || ''}`}</span>
                    )}
                    <span className='fz-14 ml-4 mr-4 text-taupe-60'>•</span>
                    <span className='fz-12 text-taupe'>
                      {propertyDetails?.data?.propertyTypeName || <Skeleton.Input style={{ height: 16 }} active={true} size='small' />}
                    </span>
                  </div>
                  <div className='share-details mt-12'>
                    {selectedProperty?.type !== 'IPO' ? (
                      <>
                        <div className='block'>
                          <span className='text-taupe-80'>Last price</span>
                          {properyLoading ? (
                            <Skeleton.Button style={{ height: 16 }} active={true} size='small' />
                          ) : (
                            <span className='subhead-3'>{`$ ${
                              getUsCurrencyFormatWithoutDecimal(selectedProperty?.lastPrice || 0) || (
                                <Skeleton style={{ height: 16 }} paragraph={{ rows: 1 }} />
                              )
                            }`}</span>
                          )}
                        </div>
                        <div className='block'>
                          <span className='text-taupe-80'>All time</span>
                          {properyLoading ? (
                            <Skeleton.Button style={{ height: 16 }} active={true} size='small' />
                          ) : (
                            <span className='subhead-3'>{`${getUsCurrencyFormat(allTime || '')} %`}</span>
                          )}
                        </div>
                        <div className='block'>
                          <span className='text-taupe-80'>
                            Div yield
                            <Tooltip
                              placement='bottom'
                              popupClassName='div-yeild-pop'
                              title='The dividend percentage is the most recent profit-sharing amount paid by Realbricks to this property’s investors. It is paid, and varies, on a quarterly basis. The dividend percentage is calculated by dividing the total dividend payment (to be split amongst share owners) by the total property purchase price (raised during the initial offering period). The dividend payment you receive will be proportional to your ownership of the property.'
                            >
                              <span>
                                <Information className='cursor-pointer' verticalAlign='sub' marginLeft='4px' color='#1A1519' />
                              </span>
                            </Tooltip>
                          </span>
                          {properyLoading ? (
                            <Skeleton.Button style={{ height: 16 }} active={true} size='small' />
                          ) : (
                            <span className='subhead-3'>{`${getUsCurrencyFormat(propertyDetails?.data?.tenantStatus?.dividendYield || 0)} %`}</span>
                          )}
                        </div>
                      </>
                    ) : (
                      <>
                        <div className='block'>
                          <span className='text-taupe-80'>Shares remaining</span>
                          <span className='subhead-3'>{getUsCurrencyFormatWithoutDecimal(selectedProperty?.sharesRemaining || 0)}</span>
                        </div>
                         {/* Comment out for CR change to hide investor count */}
                        {/* <div className='block'>
                          <span className='text-taupe-80'>Investors</span>
                          <span className='subhead-3'>{getUsCurrencyFormatWithoutDecimal(selectedProperty?.investors || 0)}</span>
                        </div> */}
                        <div className='block'>
                          <span className='text-taupe-80'>Share price</span>
                          <span className='subhead-3'>{`$ ${getUsCurrencyFormat(selectedProperty?.orderPrice || 0)}`}</span>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            }
            footer={
              selectedProperty?.type !== 'IPO' ? (
                <>
                  <Row gutter={16} className='mt-8'>
                    <Col span={12}>
                      <Button danger className='w-100 mb-16' onClick={showCancelOrderModal}>
                        Cancel Order
                      </Button>
                    </Col>
                    <Col span={12}>
                      <Button className='w-100 mb-16' onClick={showEditOrderTwo}>
                        Edit Order
                      </Button>
                    </Col>
                  </Row>
                  <p className='fz-12 text-taupe-60 text-left'>
                    Please note that orders may be executed at any time during an editing process. If this happens, any changes made to the order
                    during the edit will not be saved.
                  </p>
                </>
              ) : (
                false
              )
            }
            width={524}
            closeIcon={<CloseIcon />}
            centered
          >
            <div className='buy-content mt-20 mb-20' onScroll={(e) => handleScrollBuy(e)}>
              <p className='fw-600 mt-4'>Order details</p>
              <div className='d-flex flex-column g-16 fz-14'>
                <div className=' d-flex align-items-center justify-content-space-between'>
                  <span className='text-almost-black fw-600'>Status</span>
                  <span className='text-almost-black fw-600'>{selectedProperty?.status || ''}</span>
                </div>
                <div className=' d-flex align-items-center justify-content-space-between'>
                  <span className='text-taupe-80'>Type</span>
                  <span>{selectedProperty?.type || ''}</span>
                </div>
                <div className=' d-flex align-items-center justify-content-space-between'>
                  <span className='text-taupe-80'>Quantity</span>
                  <span>{selectedProperty?.quantity || ''}</span>
                </div>
                <div className=' d-flex align-items-center justify-content-space-between'>
                  <span className='text-taupe-80'>Price per Share</span>
                  <span>{`$${getUsCurrencyFormat(selectedProperty?.orderPrice || 0)}`}</span>
                </div>
                <div className=' d-flex align-items-center justify-content-space-between'>
                  <span className='text-taupe-80'>Total Investment (USD)</span>
                  <span className='fw-600'>{`$${getUsCurrencyFormat(grossPrice || 0)}`}</span>
                </div>
                <div className=' d-flex align-items-center justify-content-space-between'>
                  <span className='text-taupe-80'>Platform Fee</span>
                  <span>{`$${getUsCurrencyFormat(selectedProperty?.platformFee || 0)}`}</span>
                </div>
                {selectedProperty?.type === 'IPO' && (
                  <div className=' d-flex align-items-center justify-content-space-between'>
                    <span className='text-taupe-80'>Total Purchase (USD)</span>
                    <span className='fw-600'>{`$${getUsCurrencyFormat(totalPurchase || 0)}`}</span>
                  </div>
                )}
                {selectedProperty?.type !== 'IPO' && (
                  <div className=' d-flex align-items-center justify-content-space-between'>
                    <span className='text-taupe-80'>Broker-Dealer/ATS Fee (1%)</span>
                    <span>{`$ ${getUsCurrencyFormat(selectedProperty?.transactionFee) || ''}`}</span>
                  </div>
                )}
                {selectedProperty?.type !== 'IPO' && (
                  <div className=' d-flex align-items-center justify-content-space-between'>
                    <span className='text-taupe-80'>Total purchase (USD)</span>
                    <span className='fw-600'>{`$ ${Netproceeds || ''}`}</span>
                  </div>
                )}
                {selectedProperty?.type !== 'IPO' && (
                  <div className=' d-flex align-items-center justify-content-space-between'>
                    <span className='text-taupe-80'>Partial fills</span>
                    <span>{selectedProperty?.partialFills === true ? 'Yes' : 'No'}</span>
                  </div>
                )}
                {selectedProperty?.type !== 'IPO' && (
                  <div className=' d-flex align-items-center justify-content-space-between'>
                    <span className='text-taupe-80'>Duration</span>
                    <span>{selectedProperty?.duration || ''}</span>
                  </div>
                )}
              </div>
            </div>
          </Modal>
        </>
      )}
      {screenMD && (
        <Modal
          className='quickbuy buy-order ant-modal--footer-shadow ant-modal--both'
          open={EditOrderTwo}
          onCancel={hideEditOrderTwo}
          title={
            <div className={isScrolledBuy ? 'buy-order-header scrolled' : 'buy-order-header'}>
              <div className='header__img'>
                {propertyDetails?.data?.images?.[propertyDetails?.data?.images?.primaryImage] ? (
                  <LazyLoadImage
                    onError={(element) => {
                      element.target.src = Images.noPropertyFoundImage;
                    }}
                    src={propertyDetails?.data?.images?.[propertyDetails?.data?.images?.primaryImage]}
                    alt='house with garden'
                  />
                ) : (
                  <LazyLoadImage src={Images.noPropertyFoundImage} alt='the-leonardo' />
                )}
              </div>
              <div className='header__content'>
                <p className='subhead-2 text-copper mb-0'>{propertyDetails?.data?.name || ''}</p>
                <div className='name-type'>
                  <span className='fz-12 text-taupe'>{`${propertyDetails?.data?.city || ''}, ${propertyDetails?.data?.state || ''}`}</span>
                  <span className='fz-14 ml-4 mr-4 text-taupe-60'>•</span>
                  <span className='fz-12 text-taupe'>{propertyDetails?.data?.propertyTypeName || ''}</span>
                </div>
                <div className='share-details mt-12'>
                  <div className='block'>
                    <span className='text-taupe-80'>Last price</span>
                    <span className='subhead-3'>{`$ ${getUsCurrencyFormatWithoutDecimal(selectedProperty?.lastPrice || 0)}`}</span>
                  </div>
                  <div className='block'>
                    <span className='text-taupe-80'>All time</span>
                    <span className='subhead-3'>{`${allTime || ''} %`}</span>
                  </div>
                  <div className='block'>
                    <span className='text-taupe-80'>
                      Div yield
                      <Tooltip
                        placement='bottom'
                        popupClassName='div-yeild-pop'
                        title='The dividend percentage is the most recent profit-sharing amount paid by Realbricks to this property’s investors. It is paid, and varies, on a quarterly basis. The dividend percentage is calculated by dividing the total dividend payment (to be split amongst share owners) by the total property purchase price (raised during the initial offering period). The dividend payment you receive will be proportional to your ownership of the property.'
                      >
                        <span>
                          <Information className='cursor-pointer' verticalAlign='sub' marginLeft='4px' color='#1A1519' />
                        </span>
                      </Tooltip>
                    </span>
                    <span className='subhead-3'>{`${getUsCurrencyFormat(propertyDetails?.data?.tenantStatus?.dividendYield || 0)} %`}</span>
                  </div>
                </div>
              </div>
            </div>
          }
          footer={
            <>
              <Row gutter={16} className='mt-8'>
                <Col span={12}>
                  <Button danger className='w-100 mb-16' onClick={() => setEditOrderTwo(false)}>
                    Back
                  </Button>
                </Col>
                <Col span={12}>
                  <Button
                    disabled={
                      !numberOfShare ||
                      !duration ||
                      !sellPrice ||
                      Number(sellPrice) <= 0 ||
                      Number(numberOfShare) <= 0 ||
                      Number(numberOfShare) % 1 !== 0 ||
                      Number(Netproceeds) <= 0 ||
                      (selectedProperty?.type === 'Sell'
                        ? Number(numberOfShare) > Number(propertyDetails?.data?.userPurchaseDetail?.noOfShares)
                        : isMaxRangeError)
                    }
                    className='w-100 mb-16'
                    type='primary'
                    onClick={showEditOrderThree}
                  >
                    Preview order
                  </Button>
                </Col>
              </Row>
              <p className='fz-12 text-taupe-60 text-left'>
                Please note that orders may be executed at any time during an editing process. If this happens, any changes made to the order during
                the edit will not be saved.
              </p>
            </>
          }
          width={524}
          closeIcon={<CloseIcon />}
          centered
        >
          <div className='buy-content' onScroll={(e) => handleScrollBuy(e)}>
            <h4 className='fw-600 mt-40 mb-34'>{`Edit ${selectedProperty?.type} order`}</h4>
            <FloatingLabel label='Number of shares' inputId='shares' inputValue={numberOfShare}>
              <Form.Item
                className='mb-12'
                validateStatus={
                  numberOfShare &&
                  (selectedProperty?.type === 'Sell'
                    ? (Number(numberOfShare) > Number(propertyDetails?.data?.userPurchaseDetail?.noOfShares) ||
                        Number(numberOfShare) % 1 !== 0 ||
                        numberOfShare <= 0) &&
                      'error'
                    : (Number(numberOfShare) % 1 !== 0 || isMaxRangeError || numberOfShare <= 0) && 'error')
                }
                help={
                  numberOfShare &&
                  (selectedProperty?.type === 'Sell'
                    ? Number(numberOfShare) % 1 !== 0
                      ? 'Decimal numbers are not allowed.'
                      : numberOfShare <= 0
                      ? 'Please enter a number of share grater then 0.'
                      : Number(numberOfShare) > Number(propertyDetails?.data?.userPurchaseDetail?.noOfShares) &&
                        `You have exceeded the sell out limit.(i.e more than ${propertyDetails?.data?.userPurchaseDetail?.noOfShares} shares)`
                    : Number(numberOfShare) % 1 !== 0
                    ? 'Decimal numbers are not allowed.'
                    : numberOfShare <= 0
                    ? 'Please enter a number of share grater then 0.'
                    : isMaxRangeError &&
                      `You have exceeded the sell out limit.(i.e more than ${propertyDetails?.data?.userPurchaseDetail?.noOfShares} shares)`)
                }
              >
                <Input
                  value={numberOfShare}
                  onChange={(e) => setNumberOfShare(e.target.value.replace(/[^0-9]/g, ''))}
                  onSelect={(e) => {
                    window.getSelection().toString().length > 0 ? setIsTextSelected(true) : setIsTextSelected(false);
                  }}
                  onKeyPress={(event) => {
                    if (selectedProperty?.type === 'Sell') {
                      if (
                        (!/[0-9]/.test(event.key) || Number(numberOfShare) > Number(propertyDetails?.data?.userPurchaseDetail?.noOfShares)) &&
                        !isTextSelected
                      ) {
                        event.preventDefault();
                      }
                    } else {
                      if ((!/[0-9]/.test(event.key) || Number(numberOfShare) > Number(sharesRemainingToPurchase)) && !isTextSelected) {
                        event.preventDefault();
                      }
                    }
                  }}
                  id='share'
                />
              </Form.Item>
            </FloatingLabel>
            <div className='mb-30 buy-tags'>
              {selectedProperty?.type === 'Sell' ? (
                <Tag
                  className={numberOfShare?.toString() === propertyDetails?.data?.userPurchaseDetail?.noOfShares?.toString() && 'ant-tag__selected'}
                  onClick={() => setNumberOfShare(propertyDetails?.data?.userPurchaseDetail?.noOfShares?.toString() || '0')}
                >
                  {`all: ${propertyDetails?.data?.userPurchaseDetail?.noOfShares?.toString() || 0}`}
                </Tag>
              ) : (
                <>
                  <Tag
                    className={
                      Number(sharesRemainingToPurchase.toFixed(0)) < 100
                        ? 'ant-tag-disabled'
                        : numberOfShare?.toString() === '100' && 'ant-tag__selected'
                    }
                    onClick={() => setNumberOfShare('100')}
                  >
                    most popular: 100
                  </Tag>
                  <Tag
                    className={numberOfShare?.toString() === sharesRemainingToPurchase.toFixed(0).toString() && 'ant-tag__selected'}
                    onClick={() => setNumberOfShare(sharesRemainingToPurchase.toFixed(0).toString() || '0')}
                  >
                    {`max (9.8%): ${getUsCurrencyFormat(sharesRemainingToPurchase.toFixed(0) || 0)}`}
                  </Tag>
                </>
              )}
            </div>
            <FloatingLabel label='Sell price' inputId='shares' inputValue={sellPrice}>
              <Form.Item
                className='mb-12'
                validateStatus={sellPrice && sellPrice <= 0 && 'error'}
                help={sellPrice && Number(sellPrice) <= 0 && Number(sellPrice) <= 0 && 'Please enter a number of share grater then 0.'}
              >
                <Input
                  // type='number'
                  value={sellPrice}
                  onChange={(e) => setSellPrice(e.target.value.replace(/[^0-9 .]/g, ''))}
                  placeholder='$'
                  onKeyPress={(event) => {
                    if (!/[0-9 .]/.test(event.key) || (event.key === '.' && event.target.value.includes('.'))) {
                      event.preventDefault();
                    }
                  }}
                  id='limit'
                />
              </Form.Item>
            </FloatingLabel>
            <div className='mb-30 buy-tags'>
              <Tag
                className={sellPrice?.toString() === propertyDetails?.data?.highestBid?.toString() && 'ant-tag__selected'}
                onClick={() => setSellPrice(propertyDetails?.data?.highestBid?.toString() || '0')}
              >
                {`Best bid: $${getUsCurrencyFormat(propertyDetails?.data?.highestBid || 0)}`}
              </Tag>
              <Tag
                className={sellPrice?.toString() === selectedProperty?.lastPrice?.toString() && 'ant-tag__selected'}
                onClick={() => setSellPrice(selectedProperty?.lastPrice?.toString() || '0')}
              >
                {`Last price: $${getUsCurrencyFormat(selectedProperty?.lastPrice || 0)}`}
              </Tag>
            </div>
            <FloatingLabel label='Duration' inputId='duration' inputValue={duration}>
              <>
                <div id='duration2-anchor' />
                <Form.Item className='mb-12' name='duration'>
                  <Select
                    id='duration'
                    popupClassName='filter-select-dropdown'
                    onChange={(value) => setDuration(value)}
                    value={duration}
                    defaultValue={duration}
                    getPopupContainer={() => document.getElementById('duration2-anchor')}
                    onDropdownVisibleChange={() => setArrowUpDuration2(!arrowUpDuration2)}
                    suffixIcon={arrowUpDuration2 ? <ChevronUp color='#1A1519' /> : <ChevronDown color='#1A1519' />}
                  >
                    <Select.Option value='Good Until Cancel'>Good until cancel</Select.Option>
                    <Select.Option value='Good For The Day'>Good for the day</Select.Option>
                  </Select>
                </Form.Item>
              </>
            </FloatingLabel>
            <div className='basic-info'>
              <div className='basic-info__item'>
                <span className='basic-info__item__name'>Gross proceeds (USD)</span>
                <span className='basic-info__item__value'>{`$${getUsCurrencyFormat(grossProceeds || 0)}`}</span>
              </div>
              <div className='basic-info__item'>
                <span className='basic-info__item__name'>Platform fee</span>
                <span className='basic-info__item__value'>$2.50</span>
              </div>
              <div className='basic-info__item'>
                <span className='basic-info__item__name'>Broker-Dealer/ATS Fee (1%)</span>
                <span className='basic-info__item__value'>{`$${getUsCurrencyFormat(transactionFee || 0)}`}</span>
              </div>
              <div className='basic-info__item'>
                <span className='basic-info__item__name'>Net proceeds</span>
                <span className='basic-info__item__value fw-600'>{`$${Netproceeds || ''}`}</span>
              </div>
              {numberOfShare && sellPrice && Netproceeds <= 0 && (
                <span className='text-error fz-14'>Total purchase price should be greater than 0.</span>
              )}
            </div>
            <div className='mb-40 mt-20 fz-16'>
              <p className='fw-600 mb-8 cursor-pointer' onClick={() => setExpandAdvanced(!expandAdvanced)}>
                Advanced {expandAdvanced ? <ChevronUp verticalAlign='-7px' /> : <ChevronDown verticalAlign='-7px' />}
              </p>
              {!!expandAdvanced && (
                <div className='options'>
                  <Checkbox checked={isPartialFills} onChange={(e) => setIsPartialFills(e.target.checked)} className='fz-16'>
                    Accept partial fills
                    <Tooltip
                      popupClassName='div-yeild-pop'
                      title='Allow for your order to be filled in segments by smaller buyers. Doing this will give you the ability to start trading owned shares right away. Unfilled shares will be cancelled at the selected duration. '
                    >
                      <span>
                        <Information className='cursor-pointer' marginLeft='4px' verticalAlign='sub' color='#726460' />
                      </span>
                    </Tooltip>
                  </Checkbox>
                </div>
              )}
            </div>
          </div>
        </Modal>
      )}
      {screenMD && (
        <Modal
          className='quickbuy review-buy-order ant-modal--footer-shadow ant-modal--footer'
          open={EditOrderThree}
          onCancel={hideEditOrderThree}
          footer={
            <>
              <Row gutter={16} className='mt-8 mb-8'>
                <Col span={12}>
                  <Button
                    danger
                    className='w-100'
                    onClick={() => {
                      setEditOrderTwo(true);
                      setEditOrderThree(false);
                      setIsTermAndConditionChecked(false);
                    }}
                  >
                    Back
                  </Button>
                </Col>
                <Col span={12}>
                  <Button loading={loading} disabled={!isTermAndConditionChecked} className='w-100' type='primary' onClick={() => handlePlaceOrder()}>
                    Place order
                  </Button>
                </Col>
              </Row>
            </>
          }
          width={524}
          closeIcon={<CloseIcon />}
          centered
        >
          <h4 className='text-center mb-24'>{`Review ${selectedProperty?.type || ''} order`}</h4>
          <p className='fw-600'>Investment details</p>
          <div className='buy-content' onScroll={(e) => handleScrollBuy(e)}>
            <div className='d-flex flex-column g-16 fz-14'>
              <div className=' d-flex align-items-center justify-content-space-between'>
                <span className='text-taupe-80'>shares</span>
                <span className='basic-info__item__value'>{numberOfShare || ''}</span>
              </div>
              <div className=' d-flex align-items-center justify-content-space-between'>
                <span className='text-taupe-80'>Price per share</span>
                <span className='basic-info__item__value'>{`$${getUsCurrencyFormat(sellPrice || 0)}`}</span>
              </div>
              <div className=' d-flex align-items-center justify-content-space-between'>
                <span className='text-taupe-80'>Gross proceeds (USD)</span>
                <span className='basic-info__item__value'>{`$${getUsCurrencyFormat(grossProceeds || 0)}`}</span>
              </div>
              <div className=' d-flex align-items-center justify-content-space-between'>
                <span className='text-taupe-80'>Platform fee</span>
                <span className='basic-info__item__value'>$2.50</span>
              </div>
              <div className=' d-flex align-items-center justify-content-space-between'>
                <span className='text-taupe-80'>Broker-Dealer/ATS Fee (1%)</span>
                <span className='basic-info__item__value'>{`$${getUsCurrencyFormat(transactionFee || 0)}`}</span>
              </div>
              <hr />
              <div className=' d-flex align-items-center justify-content-space-between'>
                <span className='text-taupe-80'>Net proceeds (USD)</span>
                <span className='basic-info__item__value fw-600'>{`$${Netproceeds || ''}`}</span>
              </div>
              <div className=' d-flex align-items-center justify-content-space-between'>
                <span className='text-taupe-80'>Duration</span>
                <span className='basic-info__item__value'>{duration || ''}</span>
              </div>
            </div>
            <div className='d-flex mt-48'>
              <Checkbox checked={isTermAndConditionChecked} onChange={(e) => setIsTermAndConditionChecked(e.target.checked)} className='mr-16' />
              <span className='cursor-pointer fz-14'>
                <span onClick={() => setIsTermAndConditionChecked(!isTermAndConditionChecked)}>I have read and accept the </span>
                <Link to={{ pathname: '/legal', hash: 'Terms of use' }} className='underline' target='_blank'>
                  Terms of Use
                </Link>
                <span onClick={() => setIsTermAndConditionChecked(!isTermAndConditionChecked)}>, the </span>
                <Link to={{ pathname: '/legal', hash: 'Other disclosure here' }} className='underline' target='_blank'>
                  Regulation A Investment Disclosure
                </Link>
                <span onClick={() => setIsTermAndConditionChecked(!isTermAndConditionChecked)}>, and </span>
                <Link to={{ pathname: '/legal', hash: 'Privacy Policy' }} className='underline' target='_blank'>
                  Privacy Policy
                </Link>
                .
              </span>
            </div>
          </div>
        </Modal>
      )}
      {screenMD && (
        <Modal className='success' open={SuccessModal} onCancel={hideSuccessModal} closeIcon={<CloseIcon />} footer={false} width={524} centered>
          <div className='mb-16 success__vector'>
            <LazyLoadImage src={Images.success} alt='success vector art' />
          </div>
          <h4 className='success__title'>
            {orderType === 'cancel' ? 'Order cancelled' : (selectedProperty?.type || '') === 'Buy' ? 'Buy order updated' : 'Sell order updated'}
          </h4>
          <p className='mb-48 text-taupe'>
            {orderType === 'cancel'
              ? `You have successfully cancelled your order of ${numberOfShare || ''} shares ($${selectedProperty?.orderPrice || ''} each) of ${
                  selectedProperty?.property || ''
                }. You will receive a confirmation via email.`
              : selectedProperty?.type === 'Buy'
              ? `You have successfully placed a buy order of ${numberOfShare || ''} shares ($${sellPrice || ''} each) of ${
                  selectedProperty?.property || ''
                }.`
              : `You have successfully placed a Sell order of ${numberOfShare || ''} shares ($${sellPrice || ''} each) of ${
                  selectedProperty?.property || ''
                }.`}
          </p>
          <Button type='primary' className='w-100' onClick={hideSuccessModal}>
            Done
          </Button>
        </Modal>
      )}
      {screenMD && (
        <Modal open={CancelOrderModal} onCancel={hideCancelOrderModal} footer={false} closeIcon={<CloseIcon />} width={524} centered>
          <h4 className='text-center mb-16'>Are you sure you want cancel your order?</h4>
          <p className='mb-48'>
            This action cannot be undone and you may lose your place in the order queue. Alternatively, you may go back to edit your order details
            prior to any shares being bought or sold.
          </p>
          <Row gutter={[16, 16]}>
            <Col span={24} sm={12}>
              <Button className='w-100' onClick={hideCancelOrderModal}>
                Back
              </Button>
            </Col>
            <Col span={24} sm={12}>
              <Button loading={loading} className='w-100' type='primary' danger onClick={showSuccessModal}>
                Confirm
              </Button>
            </Col>
          </Row>
        </Modal>
      )}
    </>
  );
};
export default EditOrderModal;
